<div class="container">
    <mat-icon (click)="close()">close</mat-icon>
    <h2 class="header">IP's stored for Device</h2>
    <div class="ip-list">
        @for(ip of ips; track ip){
        <div class="ip-entry">
            <p class="ip">
                {{ip}}
            </p>
            @if(activeIp!=null && activeIp === ip){
            <p class="active">Active</p>
            }
        </div>
        }
    </div>
</div>